"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');







var _chat = require('shared/enum/chat');




var _smsDelivery = require('shared/services/smsDelivery');
var _common = require('shared/selectors/conversation/common');
var _selectMyOrgKeyInConvo = require('shared/selectors/conversation/selectMyOrgKeyInConvo');
var _peers = require('shared/selectors/peers');
var _relations = require('shared/selectors/user/relations');

var _selectPopulatedBlobjectSubscribers = require('./selectPopulatedBlobjectSubscribers');
var _selectConversationSMSNumbers = require('./selectConversationSMSNumbers');



















// Stable result for the common case so consumers keep their memoized
// identity even though the upstream patient map is rebuilt on every change.
 const EMPTY_CONVERSATION_SMS_UNDELIVERABLE = {
  recipientCount: 0,
  undeliverable: [],
  allUndeliverable: false,
}; exports.EMPTY_CONVERSATION_SMS_UNDELIVERABLE = EMPTY_CONVERSATION_SMS_UNDELIVERABLE

const sameRows = (a, b) =>
  a === b || (a.length === b.length && a.every((row, i) => row === b[i]))

const sameConversationSMSUndeliverable = (a, b) =>
  a === b || (
    a.recipientCount === b.recipientCount &&
    a.allUndeliverable === b.allUndeliverable &&
    a.undeliverable.length === b.undeliverable.length &&
    a.undeliverable.every((r, i) => {
      const other = b.undeliverable[i]
      return !!other && r.patient === other.patient && sameRows(r.rows, other.rows)
    })
  )

const isSecure = (conversationType) => conversationType === _chat.CHAT_TYPE.SECURE_PATIENT

// For a conversation: which patient recipients aren't deliverable, and why.
// Call as selector(state, blobjectKey).
 const makeSelectConversationSMSUndeliverable = () => _toolkit.createSelector.call(void 0, 
  _selectPopulatedBlobjectSubscribers.makeSelectPopulatedBlobjectSubscribers.call(void 0, ),
  _common.selectConversationType,
  ({ patientSubscribersList }, conversationType) => {
    const rowsFor = isSecure(conversationType) ? _smsDelivery.notificationSMSUndeliverable : _smsDelivery.orgLineSMSUndeliverable
    const undeliverable = []
    for (const patient of patientSubscribersList) {
      const rows = rowsFor(patient)
      if (rows.length > 0) undeliverable.push({ patient, rows })
    }
    if (!undeliverable.length) return exports.EMPTY_CONVERSATION_SMS_UNDELIVERABLE
    return {
      recipientCount: patientSubscribersList.length,
      undeliverable,
      allUndeliverable: undeliverable.length === patientSubscribersList.length,
    }
  },
  { memoizeOptions: { resultEqualityCheck: sameConversationSMSUndeliverable } },
); exports.makeSelectConversationSMSUndeliverable = makeSelectConversationSMSUndeliverable

// Everything the conversation banner needs: pass it to
// makeSMSUndeliverableBannerCopy (shared/services/smsDelivery).














// userDisplayName resolves a user key to a display name from the v2 then v1 maps.
 const userDisplayName = (userKey, v1, v2) => {
  if (!userKey) return null
  const v2User = _optionalChain([v2, 'optionalAccess', _ => _[userKey]])
  if (_optionalChain([v2User, 'optionalAccess', _2 => _2.Name])) return v2User.Name
  const user = v2User || _optionalChain([v1, 'optionalAccess', _3 => _3[userKey]])
  const name = user ? `${user.FirstName || ''} ${user.LastName || ''}`.trim() : ''
  return name || null
}; exports.userDisplayName = userDisplayName

const sameBannerPatients = (a, b) =>
  a.length === b.length && a.every((p, i) => {
    const other = b[i]
    return !!other && p.patient === other.patient && p.row === other.row && p.createdByName === other.createdByName
  })

const BANNER_SCALAR_KEYS = ['conversationType', 'recipientCount', 'orgKey', 'isAdmin'] 

const sameStrings = (a, b) => a === b || (a.length === b.length && a.every((value, i) => value === b[i]))

const sameBanner = (a, b) =>
  a === b || (
    BANNER_SCALAR_KEYS.every(key => a[key] === b[key]) &&
    sameStrings(a.chatNumbers, b.chatNumbers) &&
    sameBannerPatients(a.patients, b.patients)
  )

const selectViewerOrgKey = (state, blobjectKey) =>
  _selectMyOrgKeyInConvo.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey) || null

const selectViewerIsAdmin = (state, blobjectKey) => {
  const orgKey = selectViewerOrgKey(state, blobjectKey)
  return !!orgKey && _relations.selectAmIAdminInOrg.call(void 0, state, orgKey)
}

// The ONE selector for the conversation banner. Call as selector(state, blobjectKey).
 const makeSelectSMSUndeliverableBanner = () => _toolkit.createSelector.call(void 0, 
  exports.makeSelectConversationSMSUndeliverable.call(void 0, ),
  _common.selectConversationType,
  _selectConversationSMSNumbers.makeSelectConversationSMSNumbers.call(void 0, ),
  _peers.selectAllV1Users,
  _peers.selectAllV2Users,
  selectViewerOrgKey,
  selectViewerIsAdmin,
  (undeliverable, conversationType, chatNumbers, usersV1, usersV2, orgKey, isAdmin) => ({
    conversationType,
    recipientCount: undeliverable.recipientCount,
    patients: undeliverable.undeliverable.flatMap(({ patient, rows }) => {
      const row = _smsDelivery.topSMSUndeliverable.call(void 0, rows)
      return row ? [{ patient, row, createdByName: exports.userDisplayName.call(void 0, row.CreatedBy, usersV1, usersV2) }] : []
    }),
    chatNumbers,
    orgKey,
    isAdmin,
  }),
  { memoizeOptions: { resultEqualityCheck: sameBanner } },
); exports.makeSelectSMSUndeliverableBanner = makeSelectSMSUndeliverableBanner
